import {
    Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay
} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import {api} from "../utils/gashtaltAPI";
import {toast} from "react-toastify";
import {GrUpdate} from "react-icons/gr";

function PayModal({isOpen, onClose, productId}) {
    const [code, setCode] = useState("");
    const [validDiscount, setValidDiscount] = useState("");
    const [message, setMessage] = useState("");
    const purchaseHandler = async (e) => {
        try {
            const response = await api.post(`/api/exam/purchase`, {
                examId: productId,
                referer: window.location.href,
                discount_code: validDiscount === "" ? null : validDiscount
            })
            if(response.data.redirect)
                window.location.href = response.data.redirect;
            else
                window.location.reload();        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }
    }
    const isValid = async () => {
        if (code === "") {
            toast.error("کد تخفیف را به درستی وارد کنید!", {
                position: "bottom-right"
            });
            return;
        }
        try {
            const response = await api.post('/api/discount/validation', {
                code: code,
                product_id: productId,
                product_type:1
            });
            const data = response.data.data;
            setValidDiscount(code)
            setMessage(`کد تخفیف ${data.discount_amount}  درصد اعمال شد(${data.discount_amount*data.product_price/100} تومان)`)
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }
    }
    return (<Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay/>
        <ModalContent>
            <ModalHeader>پرداخت</ModalHeader>
            <ModalCloseButton/>
            <ModalBody className="exam-modal">
                <form className={"d-flex flex-column gap-1"}>
                    <div className={"custom-input-group"}>
                        <label>کد تخفیف</label>
                        <div className={"d-flex flex-row align-items-center"}>
                            <input className={`form-control`} placeholder={"کد تخفیف(انگلیسی و اعداد)"}
                                   value={code} onChange={(e) => {setMessage("");setValidDiscount("");setCode(e.target.value);}}/>
                            <Button colorScheme='green' onClick={isValid} marginX={'.5rem'}>
                                <GrUpdate/>
                            </Button>
                        </div>
                    </div>
                    <p>{message}</p>
                </form>
            </ModalBody>
            <ModalFooter>
                <Button colorScheme='gray' mr={3} onClick={onClose} marginX={'1rem'}>
                    بستن
                </Button>
                <Button colorScheme='green' onClick={purchaseHandler}>پرداخت</Button>
            </ModalFooter>
        </ModalContent>
    </Modal>)
}

export default PayModal;